export abstract class ObservableContainer extends PIXI.Container {

    private onClickedSubscribers: Array<Function> = [];
    private onPointerDownSubscribers: Array<Function> = [];
    private onPointerUpSubscribers: Array<Function> = [];

    constructor() {
        super();
    }

    public subscribeOnClicked(subscriber: Function): void {
        this.onClickedSubscribers.push(subscriber);
    }

    public subscribeOnPointerDown(subscriber: Function): void {
        this.onPointerDownSubscribers.push(subscriber);
    }

    public subscribeOnPointerUp(subscriber: Function): void {
        this.onPointerUpSubscribers.push(subscriber);
    }

    protected callOnClickedSubscribers(...args: Array<any>): void {
        for (let i = 0; i < this.onClickedSubscribers.length; i++) {
            this.onClickedSubscribers[i].apply(this, args);
        }
    }

    protected callOnPointerDownSubscribers(...args: Array<any>): void {
        for (let i = 0; i < this.onPointerDownSubscribers.length; i++) {
            this.onPointerDownSubscribers[i].apply(this, args);
        }
    }

    protected callOnPointerUpSubscribers(...args: Array<any>): void {
        for (let i = 0; i < this.onPointerUpSubscribers.length; i++) {
            this.onPointerUpSubscribers[i].apply(this, args);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/controlElements/ObservableContainer.ts